import Page from "../components/Page";
import Badge from "../components/Badge";

import * as styles from "./projects.module.css";

function Projects() {
  return (
    <Page
      title="Retrosquare - projects"
      description="The applications, games, services and other projects currently being worked on by the engineers at Retrosquare."
    >
      <section>
        <h2>Projects</h2>
        <p>
          Retrosquare is always actively conceptualizing new ways to fulfill our
          desire to make the world a better place with the production of high
          quality software and services. The following is a list of projects
          currently in development:
          <a id="praiseworthy" />
        </p>
        <div class={styles.project}>
          <h3>
            Praiseworthy{" "}
            <Badge bgColor="#FE386E" fgColor="#fff">
              In Development
            </Badge>
          </h3>
          <p>
            Think of someone in your life who deserves to hear something kind: a
            friend, a coworker, a neighbor. Praiseworthy lets you send them a
            heartfelt anonymous message of praise without any social pressure or
            awkwardness. Recipients can react with a curated set of warm
            responses, but they never find out who sent it.
          </p>
          <p>
            Anonymity isn&rsquo;t just a privacy setting. It&rsquo;s enforced at
            every layer of the system, designed so that even the server
            can&rsquo;t connect a message back to its sender. There&rsquo;s no
            password to remember either; a magic link delivered by email or SMS
            is all you need to get in. Praiseworthy launches on iOS and Android
            first, with a web version to follow.
          </p>
          <p>
            Website:{" "}
            <a href="https://praiseworthy.app" target="_blank">
              https://praiseworthy.app
            </a>
            <a id="journalous" />
          </p>
        </div>
        <div class={styles.project}>
          <h3>Journalous</h3>
          <p>
            Ever notice how much deeply personal stuff people pour into social
            media? We think it's because writing it down and sharing it actually
            helps &mdash; but the open internet is the wrong place for your most
            private thoughts. So we built the antisocial smart journal: all the
            familiar, expressive feel of a social feed, with none of the
            audience. Journalous keeps what's on your mind secure, private, and
            entirely your own.
          </p>
          <p>
            Website:{" "}
            <a href="https://journalo.us" target="_blank">
              https://journalo.us
            </a>
            <a id="littleredcouch" />
          </p>
        </div>
        <div class={styles.project}>
          <h3>Little Red Couch</h3>
          <p>
            Games should be beautiful to the eye. They should warrant the love
            of their players. And they should unlock the mind. Little Red Couch
            is a game studio that focuses primarily on these three pillars.
          </p>
          <p>
            Website:{" "}
            <a href="https://littleredcouch.com" target="_blank">
              https://littleredcouch.com
            </a>
          </p>
        </div>
        <div class={styles.project}>
          <h3>
            Proove.it{" "}
            <Badge bgColor="#000" fgColor="#fff">
              Pet Project
            </Badge>
          </h3>
          <p>
            Don't just say it; proove it! Proove.it is an image sharing website
            that allows its users to share images quickly and effectively. It
            was originally created during a 24-hour hackathon and has undergone
            metamorphosis on several occasions since then.
          </p>
          <p>
            Website:{" "}
            <a href="https://proove.it" target="_blank">
              https://proove.it
            </a>
          </p>
        </div>
      </section>
    </Page>
  );
}

export default Projects;
